<div *transloco="let t" class="row" [class.finished]="isFinished()">
  <div class="col-12 col-md-4">

    @if (schedule().venue) {
      <lucide-icon [img]="icons.map"></lucide-icon>
      <span class="ms-1">{{ venueText() }}</span>
    }

  </div>
  <div class="col-12 col-md-4">
    <app-schedule-time
      [activity]="activity()"
      [schedule]="schedule()">
    </app-schedule-time>
    <app-schedule-validity
      [activity]="activity()"
      [schedule]="schedule()">
    </app-schedule-validity>
  </div>
</div>
